// extracted by mini-css-extract-plugin
export default {"button":"PatchesListSidebar_button__pf4th","itemList":"PatchesListSidebar_itemList__C0t-y"};